/**
 * Vuetify rule sets for manual motor vehicle entry (aligned with agent sale).
 */

import {
  validateChassis,
  validateColor,
  validateEngineNo,
  validateEngineSize,
  validateSeats,
} from '@/utils/sanitize';

/** Agent sale accepts any alphanumeric logbook ref up to 10 chars (not strict K1234567A). */
export function validateMotorLogbookRef(v) {
  const s = String(v || '').trim().toUpperCase();
  return s.length >= 1 && s.length <= 10 && /^[A-Z0-9]+$/.test(s);
}

export const motorEngineNoRules = [
  (v) => !!String(v || '').trim() || 'Engine no. is required',
  (v) => validateEngineNo(v) || 'Enter 6–17 alphanumeric characters',
];

export const motorChassisNoRules = [
  (v) => !!String(v || '').trim() || 'Chassis no. is required',
  (v) => validateChassis(v) || 'Enter 10–20 characters',
];

export const motorEngineCcRules = [
  (v) => (v !== '' && v != null) || 'Engine CC is required',
  (v) => validateEngineSize(v) || 'Must be between 50 and 9999 CC',
];

export const motorColorRules = [
  (v) => !!String(v || '').trim() || 'Colour is required',
  (v) => validateColor(v) || 'Enter 2–20 characters',
];

export const motorSeatingRules = [
  (v) => (v !== '' && v != null) || 'Seating capacity is required',
  (v) => validateSeats(v) || 'Must be between 1 and 100',
];

export const motorLogbookNoRules = [
  (v) => !!String(v || '').trim() || 'Logbook number is required',
  (v) => validateMotorLogbookRef(v) || 'Enter up to 10 letters and numbers',
];

export function manualVehicleFieldsValid(vehicle = {}) {
  return !!(
    validateChassis(vehicle.chassisNumber)
    && validateEngineNo(vehicle.engineNumber)
    && validateEngineSize(vehicle.cc)
    && validateSeats(vehicle.seatingCapacity)
    && validateColor(vehicle.color)
  );
}

export function logbookFieldsValid(logBookNumber, transferred) {
  return validateMotorLogbookRef(logBookNumber) && (transferred === 'yes' || transferred === 'no');
}
